export default {
  uploading: 'Enviando',
  cancel: 'Cancelar',
  editTitle: 'Editar Modelo Ad-Hoc',
  newTitle: 'Novo Modelo Ad-Hoc',
  save: 'Salvar',
  create: 'Criar',
  modelCodename: 'Código do Modelo',
  modelName: 'Nome do Modelo',
  json: 'JSON',
  stages: 'Etapas',
  settings: 'Configurações',
  enableDataUploader: 'Habilitar Upload de Dados',
  slackChannel: 'Canal do Slack',
  enableAISummary: 'Habilitar Resumo de IA',
  impressionsModel: 'Modelo de Impressões',
  useDifferentConfigForPlans: 'Usar configuração/PKL diferente para planos',
  modelReportPkl: 'PKL do Relatório do Modelo',
  modelPkl: 'PKL do Modelo',
  downloadModelReportPkl: 'Baixar arquivo PKL do Relatório do Modelo atual',
  downloadPkl: 'Baixar arquivo PKL atual',
  noPklAvailable: 'Não há arquivo PKL disponível para este modelo',
  choosePklFile: 'Escolher arquivo PKL para enviar',
  pklRequired: 'O arquivo PKL é obrigatório',
  plansConfiguration: 'Configuração de Planos',
  plansJson: 'JSON de Planos',
  plansJsonRequired: 'O JSON de Planos é obrigatório quando se usa configuração/PKL diferente para planos',
  downloadPlansPkl: 'Baixar arquivo PKL de Planos atual',
  plansPkl: 'PKL de Planos',
  noPlansPklAvailable: 'Não há arquivo PKL de Planos disponível para este modelo',
  choosePlansPklFile: 'Escolher arquivo PKL de Planos para enviar',
  plansPklRequired: 'O arquivo PKL de Planos é obrigatório quando se usa configuração/PKL diferente para planos',
  codenameRequired: 'O código é obrigatório',
  codenameInvalid: 'O código só pode conter caracteres alfanuméricos, "-" ou "_"',
  codenameExists: 'O código já existe',
  nameRequired: 'O nome é obrigatório',
  invalidJson: 'JSON inválido',
  invalidPlansJson: 'JSON de Planos inválido',
  version: 'Versão',
  optimizerGpu: 'GPU do Plan Optimizer',
  optimizerGpuHint: 'GPU dos servidores que executam os planos do Plan Optimizer deste modelo. O Plan Calculator, o Budget Simulator e os relatórios do modelo sempre usam uma T4.',
  gpuT4: '1× T4 (padrão)',
  gpuA100: '1× A100 40GB',
  uploadFailedCreate: 'Não foi possível enviar o arquivo {file}, então o modelo não foi criado. Verifique sua conexão e tente novamente. ({error})',
  uploadFailedEdit: 'Não foi possível enviar o arquivo {file}, então as alterações não foram salvas. Verifique sua conexão e tente novamente. ({error})'
}
